/* eslint-disable import/first */
import React, { useState } from 'react';
import { Button, TextareaAutosize } from '@material-ui/core';
import { Redux } from 'spwa-ui-library';
import { useNavigate, useLocation } from '@reach/router';
const { useSelector, useDispatch } = Redux;
import { selectDesktop } from 'spwa-ui-library/esm/redux/store/appSlice';
import { selectFeedbackKeyAreas } from 'spwa-ui-library/esm/redux/store/configSlice';
import { deleteProfile, getProfile } from 'spwa-ui-library/esm/redux/store/profileSlice';
import { loginGuest, clearAuthData } from 'spwa-ui-library/esm/redux/store/authSlice';
import {
  accountDeletionFeedbackGA,
  accountDeleteSuccessGA,
} from 'spwa-ui-library/esm/utils/helperGA';
import { FormattedMessage, useIntl } from 'react-intl';
import Header from '../../components/Header';
// import { Badge } from '../../components/Icons';
import css from './index.module.scss';
import Loader from '../../components/Loader';
import BackButton from '../../components/BackButton';
import classNames from 'classnames';

const DeleteAccountFeedback = ({ navList }) => {
  const isDesktop = useSelector(selectDesktop);
  const feedbackKeyAreas = useSelector(selectFeedbackKeyAreas);
  const [selectedItems, setSelectedItems] = useState([]);
  const [desc, setDesc] = useState('');
  const [isLoading, setIsLoading] = useState('');
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const additionalComment = intl.formatMessage({ id: 'additional_comment_feedback' });

  const deleteAccountHandler = (action) => {
    accountDeletionFeedbackGA(action, selectedItems.join(','), desc);
    setIsLoading(true);
    dispatch(deleteProfile())
      .then((res) => {
        if (!res?.error) {
          dispatch(clearAuthData());
          dispatch(loginGuest()).then((resp) => {
            dispatch(getProfile());
            setIsLoading(true);
            accountDeleteSuccessGA();
            navigate(`/${intl.locale}/delete-account/success`, {
              state: {
                oldLocation: location?.state?.oldLocation,
              },
            });
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggleSelectedItems = (item) => {
    let tmpItemList = selectedItems;
    if (tmpItemList.indexOf(item) < 0) {
      tmpItemList.push(item);
    } else {
      tmpItemList.splice(tmpItemList.indexOf(item), 1);
    }
    setSelectedItems([...tmpItemList]);
  };

  const handleClose = () => {
    navigate(`/${intl.locale}/home`, { replace: true });
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className={css.deleteAccount}>
        {isDesktop && (
          <div className={css.buttonWrapper}>
            <div className={css.spacer}>
              {isDesktop && <FormattedMessage id="profile_myprofile" />}
            </div>
            <BackButton type="cross" className={css.customButton} handleBack={handleClose} />
          </div>
        )}
        {!isDesktop ? (
          <Header title={<FormattedMessage id="final_step_before_deactivation" />} />
        ) : (
          <div className={css.header}>
            <div className={classNames(css.mainHeading, css.mainHeadingFinalText)}>
              <FormattedMessage id="final_step_before_deactivation" />
            </div>
          </div>
        )}
        <div className={css.main}>
          <div className={css.profileBox}>
            <div className={css.feedbackContainer}>
              <div className={css.message}>
                <FormattedMessage id="please_give_fex_moment_for_improvement" />
              </div>
              <div className={css.heading}>
                <FormattedMessage id="key_areas_need_attention" />
              </div>
              <div className={css.feedbackList}>
                {feedbackKeyAreas?.map((listItem, index) => {
                  const itemName =
                    listItem[intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1)];
                  return (
                    <div
                      onClick={() => toggleSelectedItems(itemName)}
                      key={index}
                      className={[
                        css.listItem,
                        selectedItems.indexOf(itemName) > -1 ? css.activeItem : {},
                      ].join(' ')}
                    >
                      {itemName}
                    </div>
                  );
                })}
              </div>
              <TextareaAutosize
                className={css.feedbackTextArea}
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
                aria-label=""
                rowsMin={7}
                placeholder={additionalComment}
              />
              <div className={css.actionContainerFeedback}>
                <Button
                  variant="contained"
                  color="primary"
                  className={css.submitBtn}
                  disabled={selectedItems.length === 0}
                  onClick={() => deleteAccountHandler('SUBMIT&DELETE')}
                >
                  <FormattedMessage id="submit_and_logout" />
                </Button>
                <Button className={css.skipBtn} onClick={() => deleteAccountHandler('SKIP&DELETE')}>
                  <FormattedMessage id="skip_and_delete" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteAccountFeedback;
